import { headerSearchBarFix, updateContentMargin, modifyFeatureLineup } from './utils/helpers';
import { setNavItemAttributes, updateMenuButton } from './utils/handleNavigation';

$(document).ready(function () {
  $('.generalmessage').prependTo('header');
  headerSearchBarFix('SEARCH');
  updateMenuButton();
  modifyFeatureLineup();

  $(globalThis).on('load', function () {
    setNavItemAttributes();
    updateContentMargin();
  });
});
